import { render, staticRenderFns } from "./modelos.vue?vue&type=template&id=5df60f72&scoped=true&"
import script from "./modelos.vue?vue&type=script&lang=js&"
export * from "./modelos.vue?vue&type=script&lang=js&"
import style0 from "./modelos.vue?vue&type=style&index=0&id=5df60f72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df60f72",
  null
  
)

export default component.exports